<span *ngIf="model" style="padding: 2px 8px; background-color: white; border: solid;
border-width: 3px 1px">{{model.messageText}}</span>
